import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_LOCATION_TYPE_CATEGORY,
  UPDATE_LOCATION_TYPE_CATEGORY_DETAILS,
} from '../action-types'
import { LOCATION_TYPE_CATEGORY_INITIAL_STATE } from '../initial-states'

const locationTypeCategoryReducer = (
  state = LOCATION_TYPE_CATEGORY_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_LOCATION_TYPE_CATEGORY.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
        }),
      )

    case FETCH_LOCATION_TYPE_CATEGORY.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.locationTypeCategory,
        }),
      )

    case FETCH_LOCATION_TYPE_CATEGORY.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case FETCH_LOCATION_TYPE_CATEGORY.CLEANUP:
      return { ...LOCATION_TYPE_CATEGORY_INITIAL_STATE }

    case UPDATE_LOCATION_TYPE_CATEGORY_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case UPDATE_LOCATION_TYPE_CATEGORY_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateLocationTypeCategoryDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_LOCATION_TYPE_CATEGORY_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default locationTypeCategoryReducer
